import { render, staticRenderFns } from "./merchantClassList.vue?vue&type=template&id=2c9b333f&scoped=true&"
import script from "./merchantClassList.vue?vue&type=script&lang=js&"
export * from "./merchantClassList.vue?vue&type=script&lang=js&"
import style0 from "./merchantClassList.vue?vue&type=style&index=0&id=2c9b333f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b333f",
  null
  
)

export default component.exports